import { ApiException, ErrorDetails } from 'src/app/services/api.services';

export function getUniqueTabId(storageKey: string): string {
  let tabId = next();

  try {
    let lastTabId = sessionStorage.getItem(storageKey);

    while (lastTabId && lastTabId == tabId)
      tabId = next();

    sessionStorage.setItem(storageKey, tabId);
  }
  catch { }

  return tabId;

  function next() {
    let id = '';

    for (let i = 0; i < 16; ++i)
      id += (Math.random() * 16 | 0).toString(16);

    return id;
  }
}

export function getRepeatDelay(
  n: number,
  options: { initial: number; max: number; jitter: number; }
) {
  let initial = options.initial ?? 0;

  let delay = initial;

  if (n >= 1) {
    delay *= Math.pow(n - 1, 1.2);
  }

  delay = Math.max(delay, initial);

  if (options.max) {
    delay = Math.min(delay, options.max);
  }

  if (options.jitter) {
    let jitterAmount = Math.random();
    let jitterDelay = jitterAmount * options.jitter;
    delay += jitterDelay;
  }

  return delay;
}

export function getErrorDetails(err: any): ErrorDetails {
  if (typeof err === 'string') {
    return {
      title: 'Unexpected Error',
      detail: err,
    };
  }

  if (err instanceof ApiException) {
    return {
      title: (err.status >= 500 && err.status < 600) ? 'Server Error' : 'Unexpected Error',
      detail: err.message,
      exception: err.stack,
    };
  }

  if (err instanceof Error) {
    return {
      title: 'Unexpected Error',
      detail: err.message,
      exception: err.stack,
    };
  }

  if (typeof err === 'object') {
    return {
      title: propertyOr('title', 'Unexpected Error'),
      detail: propertyOr('detail', () => propertyOr('message')),
      exception: propertyOr('exception', () => JSON.stringify(err)),
    };
  }

  return {
    title: 'Unexpected Error',
    exception: JSON.stringify(err)
  };


  function propertyOr(key: string, fallback?: any) {
    return key in err ? err[key] : (typeof fallback === 'function' ? fallback() : fallback);
  }
}
